import { Observable } from 'rxjs';
import { AclResources } from 'src/app/shared/types/acl.types';
import { AclToolsService } from '../acl-tools.service';

export function AclResource<T extends { aclTools: AclToolsService }>(value: string | AclResources) {
  const resources = value instanceof Array ? value : [value];

  return function (target: T, propertyKey: string) {
    let observable$: Observable<boolean>;
    Object.defineProperty(target, propertyKey, {
      get(): Observable<boolean> {
        if (!observable$) {
          observable$ = this.aclTools.isAllowedFor(resources);
        }

        return observable$;
      }
    });
  };
}
